import { render, staticRenderFns } from "./SrchChild.vue?vue&type=template&id=fb2fb2c2&"
import script from "./SrchChild.vue?vue&type=script&lang=js&"
export * from "./SrchChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports